import { mark } from "@/constants/artists/mark";
import { SampleRateHz } from "@/types/defs/sampleRateHz";

export const defaultArtist = mark;

export const defaultPitchShift = 0;

export const defaultConversionStrength = 0.3;

export const defaultRemoveInstrumental = false;
export const defaultRemoveBackgroundVocals = false;
export const defaultDeReverbDeEcho = false;
export const defaultDeNoise = false;

export const defaultSampleRateHz = 44100 satisfies SampleRateHz;
